export default {
  PHASES: {
    WAITING: 'WAITING',
    ANSWERING: 'ANSWERING',
    VOTING: 'VOTING',
    LOADING: 'LOADING',
    WAIT_FOR_ANSWERS: 'WAIT_FOR_ANSWERS',
  },
};
